import Swiper, { Mousewheel, Navigation, Keyboard } from 'swiper';
Swiper.use([Mousewheel, Navigation, Keyboard]);

const projectsSlider = () => {
    /* Variables */
    let swiper;

    function reinit () {
        if (swiper) {
            swiper.destroy(false);
        }
        if (document.querySelector('.js-projects-slider')) {
            initSlider();
        }
    }

    function initSlider () {
        swiper = new Swiper('.js-projects-slider', {
            slidesPerView: 1.2,
            speed: 400,
            keyboard: {
                enabled: true
            },
            navigation: {
                nextEl: '.js-projects-slider__next',
                prevEl: '.js-projects-slider__prev'
            },
            breakpoints: {
                640: {
                  slidesPerView: 2.6
                },
                1100: {
                  slidesPerView: 3.7
                }
            }
        });

        const prevIcon = swiper.navigation.prevEl.querySelector('.js-slider-icon');
        const nextIcon = swiper.navigation.nextEl.querySelector('.js-slider-icon');

        swiper.navigation.prevEl.addEventListener('mouseleave', e => {
            prevIcon.classList.add('is-hidden');
        });
        swiper.navigation.prevEl.addEventListener('mousemove', e => {
            prevIcon.classList.remove('is-hidden');
            prevIcon.classList.add('is-visible');
            prevIcon.style.transform = `translate(${e.clientX}px, ${e.clientY}px)`;
        });
        swiper.navigation.nextEl.addEventListener('mouseleave', e => {
            nextIcon.classList.add('is-hidden');
        });
        swiper.navigation.nextEl.addEventListener('mousemove', e => {
            nextIcon.classList.remove('is-hidden');
            nextIcon.classList.add('is-visible');
            nextIcon.style.transform = `translate(${e.clientX}px, ${e.clientY}px)`;
        });
    }

    return {
        reinit
    }
};

export default projectsSlider;



// WEBPACK FOOTER //
// ./web/assets/src/js/modules/projects-slider.js